var exports = {
  "aK": "selectorButton__VveV7P",
  "Q$": "toolbarButton__eW09um",
  "wf": "simplifiedMenu__Z8fY9e",
  "KO": "simplifiedOptionLabel__QGEerK",
};

module.exports = exports;
